import React from "react";

import { TagProps, _Tag } from "./_Tag";

export function DefaultTag({
  type = "bold",
  testID = "default-tag",
  ...props
}: TagProps) {
  if (type === "bold")
    return (
      <_Tag
        fill="background-accent-tofino-strong"
        color="text-accent-tofino-weak"
        testID={testID}
        {...props}
      />
    );

  return (
    <_Tag
      fill="background-accent-tofino-weak"
      color="text-accent-tofino-strong"
      testID={testID}
      {...props}
    />
  );
}
